export default {
  auth: false,
  loading: true,
  id: null,
  name: '',
  type: '',
  fullName: '',
  departmentName: '',
  departmentId: null,
  partnerId: '',
  needSelectDepartment: null,
  partnerData: null,
  isSubAgent: false,
  isReservationCenter: true,
  features: [],
}